<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getFoaGeoJson.data.id"
      :source="getFoaGeoJson"
      :layerId="getFoaLineLayer.id"
      :layer="getFoaLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getFoaGeoJson.data.id"
      :source="getFoaGeoJson"
      :layerId="getFoaPointsLayer.id"
      :layer="getFoaPointsLayer"
    />
  </div>
</template>
      
      <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "FoaLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", ["getFoaGeoJson"]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getFoaPointsLayer",
      "getFoaLineLayer",
    ]),
  },
};
</script>